<template>
	<!-- home -->
	<div class="home">
		<div class="content">
			<div class="scanCode">
				<div class="codeimg" @click="toScanCode()">
					<img style="width: 70%;height: 60%;margin-top: 20%;margin-left: 15%;" fill
						src="@/assets/images/scancodes.png" />
				</div>
				<div class="three"><img style="width: 100%;height:100%;" src="@/assets/images/triangle.png" />
				</div>
				<div class="text">点击扫描二维码</div>
			</div>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<div >
					<div class="banner">
						<van-swipe style="height: 8rem;" :autoplay="5000">
							<van-swipe-item v-for="(image, index) in banners" :key="index">
								<!-- <img v-lazy="$baseurl.url+image.imageUrl" style="width:100%;height:8rem; fill" /> -->
								<img src="@/assets/images/banner1.svg" style="width:100%;height:8rem; fill" />
							</van-swipe-item>
						</van-swipe>
					</div>
					<ul class="list" style="margin: .5rem 0 .5rem 0">
						<li v-for="item in list" :key="item.id" @click="jump(item)">
							<p class="item-t">
								<i class="iconfont" :style="{ backgroundImage: 'url(' + item.bg + ')' }"></i>
							</p>
							<p class="item-b" style="margin-top:.5rem">{{ item.title }}</p>
						</li>
					</ul>
					<div style="width: 100%;height: 30vh;">
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Lazyload,
		Swipe,
		SwipeItem,
		PullRefresh,
	} from 'vant';
	Vue.use(Lazyload, {
		lazyComponent: true,
	});
	export default {
		name: "zhlhHome",
		components: {
			[Lazyload.name]: Lazyload,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[PullRefresh.name]: PullRefresh,
		},
		data() {
			return {
				//是否刷新
				refreshing: false,
				//轮播图
				banners: [
					{
						url:'@/assets/images/banner1.svg'
					},
					{
						url:'@/assets/images/banner1.svg'
					},
					{
						url:'@/assets/images/banner1.svg'
					},
				],
				list: [{
					icon: "icontongzhi1",
					bg: require("../../assets/images/u351.png"),
					title: "证书下载",
					id: "5",
					route: "/certlist",
				}, ],
			};
		},
		activated() {
			// console.log('home-activated')
			this.getUserInfo()
		},
		deactivated() {
			//console.log('home-deactivated')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("el-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addIndexKeepAlive', from.name);
				}
			} else {
				// if (from.meta.keepAlive) {
				// 	this.$store.commit('removeIndexKeepAlive', from.name);
				// }
			}
			//console.log(this.$store.state.indexKeepAlive)
			next();
		},
		mounted() {
			//获取工具类
			this.Tool.getTools()
		},
		created() {
		},
		methods: {
			//下载刷新
			onRefresh() {
				if (this.refreshing) {
					this.refreshing = false
				}
				this.getUserInfo()
			},
			//证书下载
			toDownCert() {
				if (this.$store.state.userInfo.certifyWay != 0) {
					this.$router.push({
						path: '/certlist',
					});
				}else{
					this.$Toast('请先在网页上进行个人认证!')
					}
			},
			//跳转二维码扫描页面
			toScanCode() {
				if (!window.plus) {
					return
				}
				this.$router.push({
					path: '/scancode',
				});
			},
			jump(item) {
				if (this.$store.state.userInfo.certifyWay === 0) {
					this.$Toast('请先进行个人认证!')
					return
				}
				if (item.route) {
					this.$router.push({
						path: item.route,
					});
				}
			},
			//获取个人信息
			getUserInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/my/api/getDetailForMobile")
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.$store.dispatch("actionUserInfo", res.data);
						}
					});
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.FFC125 {
		color: #FFC125;
	}

	.bbb {
		color: #bbb;
	}

	.home {
		position: relative;
		padding-top: 4rem;
		height: 100vh;


		.content {
			// position: relative;
			// padding: 0 0.5rem;
			// padding-bottom: 2.8rem;
			// width: 100%;
			// height: calc(100vh-4rem);
			overflow-y: auto;
			position: absolute;
			top: 4rem;
			left: 0;
			right: 0;
			bottom: 2.4rem;
			padding: 0 0.5rem;
			background: linear-gradient(180deg, #0277fc 3%, #0277fc 0, #eee 50%, #eee 100%);
			//overflow: auto;



		}

		// 修改下拉刷新字体颜色
		::v-deep .van-pull-refresh__head {
			color: white;
		}

		.scanCode {
			position: absolute;
			width: 40%;
			left: 30%;
			right: 30%;
			bottom: 2rem;
			z-index: 10;

			.codeimg {
				width: 75%;
				margin-left: 12.5%;
				aspect-ratio: 1;
				border-radius: 50%;
				background-color: #2057bc;
			}
			
			.three{
				position: absolute;
				bottom: 1.9rem;
				left: 44%;
				width: 12%;
				height: 0.8rem;
			}

			.text {
				width: 100%;
				margin-top: 1.2rem;
				line-height: 2rem;
				height: 2rem;
				color: white;
				background-color: #3175e0;
				border-radius: 1rem;
				font-size: 0.8rem;
				text-align: center;
			}
		}

	}

	.banner {
		width: 100%;
		margin-top: .5rem;
		overflow: hidden;
		border-radius: 0.3rem;
	}


	.list {
		display: flex;
		flex-wrap: wrap;
		// background: #fff;
		border-radius: 0.3rem;
		padding: 0 0.5rem;

		li {
			position: relative;
			font-size: 0.7rem;
			// background: #fff;
			width: 25%;
			text-align: center;
			overflow: hidden;
			margin: 0.5rem 0;

			.item-t {
				height: 2rem;
				width: 2rem;
				line-height: 2.5rem;
				background: #fff;
				border-radius: 50%;
				margin-left: 25%;

				i {
					background-position: center center;
					background-repeat: no-repeat;
					color: #fff;
					font-size: 0.8rem;
					display: inline-block;
					height: 1rem;
					width: 1rem;
				}
			}
		}
	}
</style>